import { config } from "JS/Config";
import { messaging } from "JS/Helpers/UserMessaging";
import VersionService from "JS/Services/Version";
import { useSnackbar } from "notistack";

export const useVersionUpdate = () => {
    const service = new VersionService();
    const isBeta = config?.appEnvironment === "beta";
    const { enqueueSnackbar } = useSnackbar();
    const fetch = (onError?: (e: any) => void) =>
        service
            .getVersion(
                isBeta ? config?.betaAppVersion : config?.appVersion,
                isBeta,
            )
            .then((r) => {
                if (r.data) {
                    enqueueSnackbar(messaging?.seamlessUpdate?.versionUpdated, {
                        variant: "info",
                    });
                    window.location.reload();
                }
            })
            .catch((e) => onError && onError(e));

    return { fetch };
};
